/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GDPRConsentResponse } from './GDPRConsentResponse';
import {
    GDPRConsentResponseFromJSON,
    GDPRConsentResponseFromJSONTyped,
    GDPRConsentResponseToJSON,
} from './GDPRConsentResponse';

/**
 * 
 * @export
 * @interface PutConsentGdpr200ResponseAllOf
 */
export interface PutConsentGdpr200ResponseAllOf {
    /**
     * 
     * @type {GDPRConsentResponse}
     * @memberof PutConsentGdpr200ResponseAllOf
     */
    result: GDPRConsentResponse;
}

/**
 * Check if a given object implements the PutConsentGdpr200ResponseAllOf interface.
 */
export function instanceOfPutConsentGdpr200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function PutConsentGdpr200ResponseAllOfFromJSON(json: any): PutConsentGdpr200ResponseAllOf {
    return PutConsentGdpr200ResponseAllOfFromJSONTyped(json, false);
}

export function PutConsentGdpr200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutConsentGdpr200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': GDPRConsentResponseFromJSON(json['result']),
    };
}

export function PutConsentGdpr200ResponseAllOfToJSON(value?: PutConsentGdpr200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': GDPRConsentResponseToJSON(value.result),
    };
}

